// src/utils/authUtils.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API;

export const verifyToken = async (token) => {
  if (!token) {
    return false;
  }

  try {
    const response = await axios.get(`${BASE_URL}/api/routeProtection`, {
      headers: {
        Authorization: token,
      },
    });
    const navItem = response?.data?.navItem;
    return {
      valid: true,
      data: navItem,
    };
  } catch (error) {
    console.error("Token verification failed:", error);
    return false;
  }
};
